import { NgModule } from '@angular/core';
import { XpoSlideSmallToggleDirective } from './toggle-small.directive';

@NgModule({
  declarations: [XpoSlideSmallToggleDirective],
  exports: [XpoSlideSmallToggleDirective],
})
export class XpoSlideToggleModule {}
